import { inject } from '@angular/core';
import { COMPANY } from '../tokens';

export const getCompany = () => inject(COMPANY);
